import { call, put, takeLeading } from 'redux-saga/effects';
import profile from '../api/profile';
import { userPasswordActions } from '../reducers/profile';

function* getUserProfileData({ payload }: any): any {
  const res = yield call(profile.fetchUserPofileData, payload);
  if (res.status === 'success') {
    yield put(userPasswordActions.getUserProfileDataResponse(res));
  } else {
    yield put(userPasswordActions.getUserProfileDataFailed(res?.code));
  }
}

function* getUserPassword({ payload }: any): any {
  const res = yield call(profile.fetchPassword, payload);
  if (res.status === 'success') {
    yield put(userPasswordActions.getUserPasswordResponse(res));
  } else {
    yield put(userPasswordActions.getUserPasswordFailed(res?.code));
  }
}

function* updateUserPasswordCall({ payload }: any): any {
  const res = yield call(profile.updatePassword, payload);
  if (res.status === 'success') {
    yield put(userPasswordActions.updateUserPasswordResponse(res.code));
  } else {
    yield put(userPasswordActions.updateUserPasswordFailed(res?.code));
  }
}

function* UserPasswordSaga() {
  yield takeLeading('profile/getUserProfileDataRequest', getUserProfileData);
  yield takeLeading('profile/getUserPassword', getUserPassword);
  yield takeLeading('profile/updateUserPasswordRequest', updateUserPasswordCall);
}

export default UserPasswordSaga;
